const formatDollars = (amountInCents: string | number) => {
  const amount = Number(amountInCents) / 100;
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export default formatDollars;
